import { Api } from '../api/Api.js'

// دریافت اطلاعات حواله ها
export function apiGetReferredDetails(body) {
  return Api('post', '/loads/referreds_detail', {body})
}


// دریافت اطلاعات یک بار
export function apiGetLoad(load_id) {
  return Api('get', '/loads/get_load/' + load_id)
}

// دیافت لیست انبار ها
export function apiGetWarehouses(params) {
  return Api('get', '/warehouse/get_all_warehouses', {params})
}


// ثبت بارگیری
export function apiSetFinalLoading(body) {
  return Api('post', '/loads/final_loading', {body})
}


